import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

const orderService = {
  // Create a new order and initiate payment
  async createOrder(payload) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.ORDERS.BASE, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get user order history
  async getUserOrders(params) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.ORDERS.USER_LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Admin: Get all orders
  async getAdminOrders(params) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.ORDERS.LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Admin: Get all transactions
  async getAdminTransactions(params) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.ORDERS.TRANSACTION_LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get order details by ID
  async getOrderById(uuid) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.ORDERS.VIEW(uuid));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Admin: Cancel an order with a reason
  async cancelOrder(uuid, reason) {
    try {
      const response = await axiosInstance.put(ENDPOINTS.ORDERS.STATUS_UPDATE(uuid), {
        order_status: 'cancelled',
        reason,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify payment status
  async verifyPayment(payload) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.ORDERS.VERIFY_PAYMENT, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create payment for multiple orders
  async createPayment(payload) {
    try {
      const response = await axiosInstance.post(ENDPOINTS.ORDERS.CREATE_PAYMENT, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get transaction details by UUID
  async getTransactionById(uuid) {
    try {
      const response = await axiosInstance.get(ENDPOINTS.ORDERS.TRANSACTION_VIEW(uuid));
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default orderService;
